import React, { useEffect, useState } from 'react'
import useLocalStorage from '../../hooks/useLocalStorage'
import { FEATURES, LOCAL_STORAGE_KEYS } from '../../../constants'
import { useMeQuery } from '@graphql/queries/__generated__/me.generated'
import Snackbar from '@mui/material/Snackbar'
import { useHistory } from 'react-router'
import { WHOLESALE_ROUTES } from '../../urls'
import dayjs from 'dayjs'
import WholesalePartnerNotification from '@components/Notifications/WholesalePartnerNotification'
import { SnackbarCloseReason } from '@mui/material/Snackbar/Snackbar'
import { useTheme } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'

const NOTIFICATIONS_CONFIG = {
  DELAY_TO_INIT: 10, // seconds
  DELAY_TO_SHOW: 14, // days
  DELAY_TO_DISABLE: 10, // years
  INTERVAL_TIMEOUT: 5000,
  AUTO_HIDE: 10000, // 10 seconds
}

interface Props {}

const Notifications: React.FC<Props> = ({}) => {
  const history = useHistory()
  const theme = useTheme()
  const smDown = useMediaQuery(theme.breakpoints.down('sm'))
  const [storageNotifications, setStorageNotifications] = useLocalStorage(LOCAL_STORAGE_KEYS.NOTIFICATIONS, {
    becomeWholesalePartner: dayjs().add(NOTIFICATIONS_CONFIG.DELAY_TO_INIT, 'seconds').toISOString(),
  })
  const [now, setNow] = useState(dayjs().toISOString())
  const [timer, setTimer] = useState(null)

  const meQuery = useMeQuery({ fetchPolicy: 'cache-first', nextFetchPolicy: 'cache-first' })

  useEffect(() => {
    let timer = null
    if (FEATURES.WHOLESALE && dayjs(storageNotifications.becomeWholesalePartner).diff(now, 'hours') < 1) {
      timer = setInterval(() => setNow(dayjs().toISOString()), NOTIFICATIONS_CONFIG.INTERVAL_TIMEOUT)
    }
    setTimer(timer)
    return () => clearInterval(timer)
  }, [FEATURES.WHOLESALE])

  const handleClose = (event?: React.SyntheticEvent, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') return
    setStorageNotifications({
      ...storageNotifications,
      becomeWholesalePartner: dayjs().add(NOTIFICATIONS_CONFIG.DELAY_TO_SHOW, 'days').toISOString(),
    })
    clearInterval(timer)
    setTimer(null)
  }

  const showBecomePartner =
    FEATURES.WHOLESALE &&
    !meQuery.loading &&
    !meQuery.data?.me?.wholesaleApp &&
    storageNotifications &&
    dayjs(storageNotifications.becomeWholesalePartner).isBefore(now)

  return (
    <Snackbar
      open={showBecomePartner}
      onClose={handleClose}
      autoHideDuration={NOTIFICATIONS_CONFIG.AUTO_HIDE}
      anchorOrigin={{ horizontal: smDown ? 'center' : 'left', vertical: 'bottom' }}
      ContentProps={{
        sx: {
          backgroundColor: '#fff',
          borderRadius: '20px',
          maxWidth: smDown ? '450px' : '330px',
          padding: smDown ? '0' : '6px 16px',
        },
      }}
      message={
        <WholesalePartnerNotification
          onBecomePartner={() => {
            history.push(WHOLESALE_ROUTES.REGISTRATION)
            handleClose()
          }}
          onWatchProducts={() => {
            history.push(WHOLESALE_ROUTES.PRODUCTS)
            handleClose()
          }}
          onDisable={() => {
            setStorageNotifications({
              ...storageNotifications,
              becomeWholesalePartner: dayjs().add(NOTIFICATIONS_CONFIG.DELAY_TO_DISABLE, 'years').toISOString(),
            })
            clearInterval(timer)
            setTimer(null)
          }}
          onClose={handleClose}
        />
      }
    />
  )
}

export default Notifications
